import React from "react";
import Page, { PageProps } from "../Page";
import DataGrid from "../../components/app/grid/DataGrid";
import { Form } from "antd";
import { IEvaluationTypesPresenter } from "../../../presenter/evaluation/EvaluationTypesPresenter";
import CreateEvaluationTypeForm, {
  CreateEvaluationTypeFormProps
} from "./CreateEvaluationTypeForm";
import UpdateEvaluationTypeForm, {
  UpdateEvaluationTypeFormProps
} from "./UpdateEvaluationTypeForm";
import EvaluationTypesDataGrid from "./EvaluationTypesDataGridExpanded";
import Loader from "../../components/Loader";
export interface Props extends PageProps {}
export interface State extends IEvaluationTypesPresenter {}

export default class EvaluationTypesPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      evaluationTypes = [],
      createEvaluationType,
      updateEvaluationType,
      assignedRuleGroupsIds,
      ruleGroups
    } = this.state;
    const CreateForm = Form.create<CreateEvaluationTypeFormProps>({})(
      CreateEvaluationTypeForm
    );

    const UpdateForm = Form.create<UpdateEvaluationTypeFormProps>({})(
      UpdateEvaluationTypeForm
    );

    const columns = [
      {
        title: translate("evaluationTypes_page.name"),
        dataIndex: "name",
        key: "name"
      },
      {
        title: translate("evaluationTypes_page.description"),
        dataIndex: "description",
        key: "description"
      },
      {
        title: translate("evaluationTypes_page.rule"),
        key: "rule",
        dataIndex: "rule"
      }
    ];
    const expandedRowRender = e => {
      return (
        <EvaluationTypesDataGrid
          translate={translate}
          ruleGroupLoader={this.state.loaders.ruleGroupLoader}
          assignedRuleGroupsIds={assignedRuleGroupsIds}
          ruleGroups={ruleGroups}
          onRuleGroupSelectChange={this.state.onRuleGroupSelectChange}
        />
      );
    };

    const dataGrid = (
      <DataGrid
        title={translate("grids.evaluation-types")}
        translate={translate}
        columns={columns}
        dataSource={evaluationTypes}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        createForm={CreateForm}
        updateForm={UpdateForm}
        onCreate={createEvaluationType}
        onUpdate={updateEvaluationType}
        createModalTitle={translate("evaluationTypes_page.insert_modal_title")}
        updateModalTitle={translate("evaluationTypes_page.update_modal_title")}
        expandedRowRender={expandedRowRender}
        singleRowExpandEnabled={true}
        onExpand={this.state.onRowExpanded}
        addButtonText={translate("evaluationTypes_page.add_button_text")}
      />
    );

    return (
      <Page {...this.props}>
        <Loader
          children={dataGrid}
          translate={translate}
          loading={this.state.loaders.evaluationTypesLoader}
        />
      </Page>
    );
  }
}
